import React from 'react';
import { useVideoDetail } from './presenter';
import { VideoDetailView } from './view';
import { Route } from '../../../components/layout/ProtectedLayout';

type Props = {
  id: string;
  navigate: (r: Route) => void;
};

const VideoViewPage: React.FC<Props> = ({ id, navigate }) => {
  const vm = useVideoDetail(id);
  return (
    <VideoDetailView
      data={vm.data}
      loading={vm.loading}
      error={vm.error}
      onBack={() => navigate({ name: 'videos/index' as any })}
    />
  );
};

export default VideoViewPage;
